'use client';
import apiClient from './apiClient';

class EventClient {
    // 依活動類型取得活動資訊
    getEvent = (slug) => apiClient.get(`/activity/slug/${slug}`);

    // 取得投票活動
    getEventList = ({ actType = '1', page = 1, limit = 3 }) =>
        apiClient.get('/activity/current/list', {
            params: {
                actType,
                page,
                limit,
            },
        });

    /* ------------ 上線摩天輪活動 ------------ */
    getSetting = () => apiClient('/spin/setting');

    getUserInfo = () => apiClient('/spin/user-info');

    verifyTask = (taskId) => apiClient.post(`/spin/verify-task/${taskId}`);

    wheelDraw = () => apiClient.post('/spin/draw');

    /* ------------ 投稿吧少女 ------------ */
    getFavoriteRank = ({ tagId }) => apiClient(`/event/favorite-rank?tagId=${tagId}`);

    // 預熱活動登記
    registerPreRegistration = (
        model = { userId: 28, preRegistrationId: 3, countryCode: '+886', phone: '0916585868' },
    ) =>
        apiClient.post('/event/pre-register/register', {
            ...model,
        });

    /* ------------ 男友排行 ------------ */
    // 投票
    postVote = ({ optionIds }) =>
        apiClient.post('/boyfriend/ticket', {
            optionIds,
        });

    // 新增選項
    postOption = ({ roleName, workName }) =>
        apiClient.post('/boyfriend/boyfriend-option', {
            roleName,
            workName,
        });

    /* ------------ acg 偶像排行 ------------ */
    // 曝光/點擊回報
    postIdolInteraction = ({ id, position, eventType }) =>
        apiClient.post('/idol/interaction', { id, position, eventType });

    // 投票
    postVoteIdol = ({ optionIds, id, fromApp }) => {
        const stored = JSON.parse(sessionStorage.getItem('entrySource') || '{}');
        const referrer = stored.referrer || undefined;
        const source = stored.source || undefined;
        return apiClient.post('/idol/ticket', {
            optionIds,
            id,
            platform: fromApp ? 'app' : 'web',
            ...(referrer && { referrer }),
            ...(source && { source }),
        });
    };

    // 新增選項
    postIdolOption = ({ roleName, workName, id }) =>
        apiClient.post('/idol/option', {
            roleName,
            workName,
            id,
        });

    // 取得投票選項
    getIdolOptions = (id = 1) => apiClient.get('/idol/option', { params: { id } });

    // 取得排行榜
    getIdolRank = (id = 1) => apiClient.get('/idol/leaderboard', { params: { id } });

    // 取得聲量榜
    getTrendsRank = (id = 1) => apiClient.get('/idol/buzz-ranking', { params: { id } });

    // 星塵兌換選票
    exchangeTicket = (id = 1) => apiClient.post('/idol/exchange-stardust-for-ticket', { id });

    /* 簽到 */
    checkIn = () => apiClient.post('/checkin/checkin-log');

    // 取得打卡狀態
    getCheckInReport = () => apiClient.get('/checkin/checkin-report');
}

const eventClient = new EventClient();

export default eventClient;
